import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { OIV_TYPE } from '@mobi/oiv-viewer-xml-parser-ng-jslib';

import { Content } from '../common.interface';
import { tealiumTrackingActions } from '../store/tealium-tracking/tealium-tracking.actions';

@Injectable({ providedIn: 'root' })
export class TealiumTrackingFacade {
    #store = inject(Store) as Store<any>;

    addVolatile(key: string, value: string | string[]) {
        this.#store.dispatch(tealiumTrackingActions.addVolatile({ key, value }));
    }

    trackChangeLanguage(language: string): void {
        this.#store.dispatch(tealiumTrackingActions.trackChangeLanguage({ language }));
    }

    trackPageView(pageContent: Content, titleType: OIV_TYPE.CHAPTER_TITLE | OIV_TYPE.TOPIC_TITLE): void {
        if (Array.isArray(pageContent.content)) {
            const pageTitle = pageContent.content.find((item: Content) => item.type === titleType);
            this.#store.dispatch(
                tealiumTrackingActions.trackPageView({ title: pageTitle ? (pageTitle.content as string) : '' }),
            );
        }
    }

    trackHomePageView(title: string): void {
        this.#store.dispatch(tealiumTrackingActions.trackPageView({ title }));
    }

    trackIndexPageView(title: string, customEvent: object): void {
        this.#store.dispatch(tealiumTrackingActions.trackPageView({ title, customEvent }));
    }

    trackDocumentDownloadEvent(filetype: string, title: string, downloadUrl: string): void {
        this.#store.dispatch(tealiumTrackingActions.trackDocumentDownloadEvent({ filetype, title, downloadUrl }));
    }

    trackButtonClickEvent(buttonName: string, buttonTarget: string): void {
        this.#store.dispatch(tealiumTrackingActions.trackButtonClickEvent({ buttonName, buttonTarget }));
    }

    trackInteractionEvent(
        elementName: string,
        elementType: string,
        elementValue: string,
        interactionType: string,
    ): void {
        this.#store.dispatch(
            tealiumTrackingActions.trackInteractionEvent({
                elementName,
                elementType,
                elementValue,
                interactionType,
            }),
        );
    }
}
